import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'clipboard-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <circle
                    class="svgWrapperShape"
                    id="msg-path-1"
                    cx="53"
                    cy="53"
                    r="53"
                />
                <polygon
                    id="msg-path-3"
                    points="0 0 45 0 45 50.998725 0 50.998725"
                />
            </defs>
            <g
                id="msg-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="msg-B-Person-page--more-people-added-"
                    transform="translate(-944.000000, -1861.000000)"
                >
                    <g
                        id="msg-Group-13"
                        transform="translate(947.000000, 1864.000000)"
                    >
                        <g id="msg-Screen-Shot-2019-01-14-at-5.33.33-PM">
                            <mask id="msg-mask-2" fill="white">
                                <use xlink:href="#msg-path-1" />
                            </mask>
                            <use
                                id="msg-Mask"
                                stroke="#0092C8"
                                stroke-width="4.4"
                                fill="#F3FBFE"
                                fill-rule="nonzero"
                                xlink:href="#msg-path-1"
                            />
                        </g>
                        <g
                            id="msg-Group-6"
                            transform="translate(30.000000, 27.000000)"
                        >
                            <g id="msg-Group">
                                <g id="msg-Group-3">
                                    <mask id="msg-mask-4" fill="white">
                                        <use xlink:href="#msg-path-3" />
                                    </mask>
                                    <g id="msg-Clip-2" />
                                    <path
                                        d="M41.7857143,47.811225 L3.21428571,47.811225 L3.21428571,9.561225 L9.64285714,9.561225 L9.64285714,14.342475 C9.64285714,15.222225 10.3628571,15.936225 11.25,15.936225 L33.75,15.936225 C34.6371429,15.936225 35.3571429,15.222225 35.3571429,14.342475 L35.3571429,9.561225 L41.7857143,9.561225 L41.7857143,47.811225 Z M22.5,3.186225 C24.2742857,3.186225 25.7142857,4.614225 25.7142857,6.373725 C25.7142857,8.1364125 24.2742857,9.561225 22.5,9.561225 C20.7257143,9.561225 19.2857143,8.1364125 19.2857143,6.373725 C19.2857143,4.614225 20.7257143,3.186225 22.5,3.186225 L22.5,3.186225 Z M43.3928571,6.373725 L28.9285714,6.373725 C28.9285714,2.854725 26.0517857,-0.001275 22.5,-0.001275 C18.9482143,-0.001275 16.0714286,2.854725 16.0714286,6.373725 L1.60714286,6.373725 C0.72,6.373725 0,7.0909125 0,7.967475 L0,49.404975 C0,50.284725 0.72,50.998725 1.60714286,50.998725 L43.3928571,50.998725 C44.28,50.998725 45,50.284725 45,49.404975 L45,7.967475 C45,7.0909125 44.28,6.373725 43.3928571,6.373725 L43.3928571,6.373725 Z"
                                        id="msg-Fill-1"
                                        fill="#3D1C70"
                                        mask="url(#msg-mask-4)"
                                    />
                                </g>
                                <polygon
                                    id="msg-Fill-4"
                                    fill="#3D1C70"
                                    points="19.2528609 42.234375 8.83928571 30.1880947 11.8071709 27.2179571 19.2528609 33.0444962 33.1928291 20.71875 36.1607143 23.6888876"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class ClipboardIconComponent {
    @Input()
    iconSize: IconSize;
}
